import {useGroupListQuery} from '../../graphql';
import {GroupListContainer} from './container';
import {ErrorView} from '../GraphQL/ErrorView';
import React from 'react';

export const GroupListGraphQL = () => {
  const [groupListResult] = useGroupListQuery({requestPolicy: 'network-only'});
  const {data, fetching, error} = groupListResult;
  const groups = data?.groups ?? [];

  return (
    <ErrorView fetching={fetching} errors={[error]}>
      <GroupListContainer groups={groups}/>
    </ErrorView>
  );
};
